import { Link } from 'react-router-dom'
import { Menu, X, Github, MessageCircle } from 'lucide-react'
import { useState } from 'react'

export default function Header() {
	const [isMenuOpen, setIsMenuOpen] = useState(false)

	return (
		<header className="sticky top-0 z-50 bg-vscode-sidebar/95 backdrop-blur-sm border-b border-vscode-border">
			<nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="flex justify-between items-center h-16">
					<Link to="/" className="flex items-center space-x-3">
						<img src="/logo-dark.svg" alt="SakaDev" className="w-8 h-8" />
						<span className="text-xl font-semibold text-vscode-text-bright font-sans">SakaDev</span>
					</Link>

					{/* Desktop Navigation */}
					<div className="hidden md:flex items-center space-x-8">
						<Link to="/features" className="text-vscode-text hover:text-vscode-text-bright transition-colors font-sans">
							Features
						</Link>
						<Link to="/docs" className="text-vscode-text hover:text-vscode-text-bright transition-colors font-sans">
							Documentation
						</Link>
						<a 
							href="https://github.com/rahmanazhar/SakaDev" 
							target="_blank" 
							rel="noopener noreferrer"
							className="text-vscode-text hover:text-vscode-text-bright transition-colors"
						>
							<Github className="w-5 h-5" />
						</a>
						<a 
							href="https://discord.gg/vcEVyctwYt" 
							target="_blank" 
							rel="noopener noreferrer"
							className="text-vscode-text hover:text-vscode-text-bright transition-colors"
						>
							<MessageCircle className="w-5 h-5" />
						</a>
						<a
							href="https://marketplace.visualstudio.com/items?itemName=rahmanazhar.saka-dev"
							target="_blank"
							rel="noopener noreferrer"
							className="px-4 py-2 bg-vscode-accent hover:bg-vscode-accent-hover text-white rounded transition-colors font-medium font-sans"
						>
							Install Extension
						</a>
					</div>

					{/* Mobile Menu Button */}
					<button
						onClick={() => setIsMenuOpen(!isMenuOpen)}
						className="md:hidden p-2 text-vscode-text hover:text-vscode-text-bright"
					>
						{isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
					</button>
				</div>

				{/* Mobile Navigation */}
				{isMenuOpen && (
					<div className="md:hidden py-4 space-y-4">
						<Link 
							to="/features" 
							className="block text-vscode-text hover:text-vscode-text-bright transition-colors font-sans"
							onClick={() => setIsMenuOpen(false)}
						>
							Features
						</Link>
						<Link 
							to="/docs" 
							className="block text-vscode-text hover:text-vscode-text-bright transition-colors font-sans"
							onClick={() => setIsMenuOpen(false)}
						>
							Documentation
						</Link>
						<a 
							href="https://github.com/rahmanazhar/SakaDev" 
							target="_blank" 
							rel="noopener noreferrer"
							className="flex items-center space-x-2 text-vscode-text hover:text-vscode-text-bright transition-colors"
						>
							<Github className="w-5 h-5" />
							<span className="font-sans">GitHub</span>
						</a>
						<a 
							href="https://discord.gg/sakadev" 
							target="_blank" 
							rel="noopener noreferrer"
							className="flex items-center space-x-2 text-vscode-text hover:text-vscode-text-bright transition-colors"
						>
							<MessageCircle className="w-5 h-5" />
							<span className="font-sans">Discord</span>
						</a>
						<a
							href="https://marketplace.visualstudio.com/items?itemName=rahmanazhar.saka-dev"
							target="_blank"
							rel="noopener noreferrer"
							className="block w-full text-center px-4 py-2 bg-vscode-accent hover:bg-vscode-accent-hover text-white rounded transition-colors font-medium font-sans"
						>
							Install Extension
						</a>
					</div>
				)}
			</nav>
		</header>
	)
}